import { network } from 'services/network';

export const roleCreate = (params) => {
    return network.post('admin/bo/roleCreate', params).then((response) => {
        return response.data;
    });
};
